import { createRequest } from '@shared/services';

export async function getShippingMethod(args: GetProductShippingMethodParams) {
    const { product_id, ship_to, quantity } = args;

    const request = createRequest<GetProductShippingMethodResponse>({
        url: `/product/${product_id}/shipping-method`,
        method: 'GET',
        withAuthorization: true,
        params: {
            ship_to,
            quantity,
        },
    });

    return request.execute();
}
